import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { EXPENSES_GET_MANY } from 'api/query-keys.ts';
import type { TExpenseRes } from 'api/swagger';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  orderId?: number;
  tripId?: number;
  whTaskId?: number;
  clientId?: number;
}

export const useGetManyExpensesByEntity = (params?: IParams) => {
  const { limit = PAGINATION_DEFAULT_LIMIT, page = 1, orderId, tripId, whTaskId, clientId } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (orderId) qs.set('filter[orderId]', String(orderId));
  if (tripId) qs.set('filter[tripId]', String(tripId));
  if (whTaskId) qs.set('filter[warehouseTaskId]', String(whTaskId));
  if (clientId) qs.set('filter[clientId]', String(clientId));

  return useQuery<WithPagination<TExpenseRes[]>>({
    queryKey: [EXPENSES_GET_MANY, page, limit, qs.toString()],
    queryFn: async () => {
      const { data, headers } = await http.get<TExpenseRes[]>(`/v1/expenses?${qs.toString()}`);
      const pagination = preparePagination(headers);

      return { data, pagination };
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 0,
    cacheTime: 0,
  });
};
